<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="500">
    <template v-slot:title>{{ title }}</template>
    <v-container>
      <v-row justify="center" align="center" v-if="!this.value.isAttachment">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-1" color="primary" v-bind="attrs" v-on="on">
              <v-icon left>mdi-pdf-box</v-icon>
              Share PDF
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="onShareWithAgent('PDF')">
              <v-list-item-title>Share with Agent</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onShareWithClient('PDF')">
              <v-list-item-title>Share with Client</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onShare('PDF')">
              <v-list-item-title>Get Link</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-1" v-bind="attrs" v-on="on" color="primary">
              <v-icon left>mdi-language-html5</v-icon>
              Share HTML
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="onShareWithAgent('HTML')">
              <v-list-item-title>Share with Agent</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="onShareWithClient('HTML')"
                >Share with Client</v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="onShare('HTML')">
              <v-list-item-title>Get Link</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
      <v-row v-if="shareURL != ''">
        <v-container pb-0>
          <v-textarea v-model="shareURL" ref="textToCopy" outlined></v-textarea>
        </v-container>
        <v-row align="center" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                fab
                dark
                color="cyan"
                v-bind="attrs"
                v-on="on"
                @click="copyLink"
              >
                <v-icon dark>mdi-content-copy </v-icon>
              </v-btn>
            </template>
            <span>Copy To Clipboard</span>
          </v-tooltip>
        </v-row>
      </v-row>
    </v-container>
    <code v-if="debug"> val: {{ value }} </code>
  </basic-dialog>
</template>

<script>
import BasicDialog from "./BasicDialog";
import gql from "graphql-tag";
const SHARE_DOC_MUTATION = gql`
  mutation shareDoc($docId: ID!, $format: ShareDocFormatType!) {
    shareDocument(documentId: $docId, format: $format) {
      success
      url
      error
    }
  }
`;
export default {
  name: "share-dialog",

  props: {
    title: {
      type: String,
      default: () => "Share",
    },
    show: {
      type: Boolean,
      value: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      debug: false,
      shareURL: this.value.isAttachment ? this.value.downloadURL : "",
    };
  },

  methods: {
    copyLink() {
      const textToCopy = this.$refs.textToCopy.$el.querySelector("textarea");
      textToCopy.select();
      document.execCommand("copy");
    },
    onShare(format, cb) {
      if (this.value && this.value.id) {
        const docId = this.value.id;
        this.$apollo
          .mutate({
            mutation: SHARE_DOC_MUTATION,
            variables: { docId, format },
          })
          .then(({ data }) => {
            if (data.shareDocument.success) {
              this.shareURL = data.shareDocument.url;
            }
            if (cb) {
              cb();
            }
          })
          .catch((err) => console.log(err));
      }
    },
    onShareWithAgent(format) {
      this.onShare(format, () =>
        this.$emit("contact-agent", {
          shareLink: this.shareURL,
          message: this.shareURL,
        })
      );
    },
    onShareWithClient(format) {
      this.onShare(format, () =>
        this.$emit("contact-client", {
          shareLink: this.shareURL,
          message: this.shareURL,
        })
      );
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ShareDialog.vue